import {useQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {parseAxiosPromise} from '@/axiosInstance.ts'
import {captureException} from '@sentry/react'
import {httpUserAdminMe} from '../http/admin.http'
import {useAuthStore} from '@features/user/store/store'
import {AdminUser} from '../types'

export const useAdminMe = () => {
    const adminAccessToken = useAuthStore(state => state.adminAccessToken) ?? ''
    return useQuery({
        queryKey: [QUERY_KEYS.ADMIN_ME, adminAccessToken],
        queryFn: () =>
            parseAxiosPromise({
                axiosPromise: httpUserAdminMe({urlParams: {adminAccessToken}}),
                responseShape: AdminUser,
                onZodError: captureException
            }),
        enabled: !!adminAccessToken
    })
}
